import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../hoc/Auxilliary";
import Documents from "../../components/Documents";

const DocumentsPage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <Documents />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default DocumentsPage;
